export default {
  addFile: 'Add file',
  changeFile: 'Change file',
  attach: 'Attach files',
  attachFromProject: 'Attach files from project',
  areYouSureYouWantToDelete: 'Are you sure you want to delete?',
  closeWhileUploadingTitle: 'Close while files are uploading?',
  closeWhileUploadingDescription: `Some files are still uploading. If you close this window, they won't be attached to the message.`,
  failedToUpload: 'Failed to upload file',
  fileFromComputer: 'File from computer',
  fileFromProject: 'File from project',
  filesAdded: 'Files Added',
  filesAttached: 'Files attached',
  fileUploaded: 'File uploaded',
  jpg: 'JPG',
  plural: 'Files',
  png: 'PNG',
  removeFiles: 'Remove files',
  restoreFiles: 'Restore files',
  selectFileFormat: 'Select file format',
  selectFiles: 'Select files',
  startFilesUploading: 'Start files uploading',
  tiff: 'TIFF',
  uploadToLd: 'Upload to LD',
  viewLdFile: 'View LD file'
};
